import Axios from 'axios';
import { ListResponse } from 'model/api';

export const getCountryList = async (): Promise<ListResponse> => {
  const response = await Axios.get('/lists/country');
  return response.data;
}

export const getRegionList = async (countryId: string): Promise<ListResponse> => {
  const response: { data: ListResponse } = await Axios.get(`/lists/region_${countryId}`);
  return { items: response.data.items.map(it => ({ ...it, key: it.key.toUpperCase() })) }
}

export const getTimezoneList = async (countryId: string, stateId: string | null): Promise<ListResponse> => {
  let response;
  if (stateId) {
    response = await Axios.get(`/lists/timezone_${countryId}_${stateId.toLowerCase()}`);
  } else  {
    response = await Axios.get(`/lists/timezone_${countryId}`);
  }
  return response.data;
}